<template>
    <div class="content">
        <div class="md-layout">
            <div class="md-layout-item md-size-100">
                <md-card>
                    <md-card-header data-background-color="primary">
                        <h4 class="title">Calendar</h4>
                        <div class="calendar-navigation">
                            <md-button @click="previousMonth">
                                <md-icon>keyboard_arrow_left</md-icon>
                            </md-button>
                            <h5>{{ month }}</h5>
                            <md-button @click="nextMonth">
                                <md-icon>keyboard_arrow_right</md-icon>
                            </md-button>
                        </div>
                        <div class="calendar-header">
                            <div class="calendar-day">
                                <p>Mon</p>
                            </div>
                            <div class="calendar-day">
                                <p>Tue</p>
                            </div>
                            <div class="calendar-day">
                                <p>Wed</p>
                            </div>
                            <div class="calendar-day">
                                <p>Thu</p>
                            </div>
                            <div class="calendar-day">
                                <p>Fri</p>
                            </div>
                            <div class="calendar-day">
                                <p>Sat</p>
                            </div>
                            <div class="calendar-day">
                                <p>Sun</p>
                            </div>
                        </div>
                        <!-- <p class="category">Complete or edit your profile</p> -->
                    </md-card-header>
                    <md-card-content>
                        <div class="calendar-wrapper">
                            <div v-for="(date, index) in dates" v-bind:key="index" class="calendar-date" :class="date.inMonth ? '' : 'calendar-not-in-month'">
                                <div class="calendar-date-container" :class="{'weekend': date.isWeekend, 'selected': index === selectedIndex, 'holiday': date.isHoliday, 'vacation': date.isVacation, 'recup': date.recup, 'recup': date.halfDayRecup, 'halfday': date.halfDayVacation, 'sick': date.sick, 'half-sick': date.halfSick}" @click="date.inMonth ? selectDay(date, index) : ''">
                                    <p>{{ date.date }}</p>
                                    <p class="hours">{{ format(date.hours) }}</p>
                                </div>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
            <div class="md-layout-item md-size-100">
                <nav-tabs-card>
                    <template slot="content">
                        <span class="md-nav-tabs-title">Info:</span>
                        <md-tabs :md-active-tab="activeTab" @md-changed="(id) => {activeTab = id}" class="md-primary" md-alignment="right">
                            <md-tab id="tab-month" md-label="Month" md-icon="calendar_today">
                                <md-table table-header-color="primary">
                                    <md-table-row>
                                        <md-table-cell>Working days</md-table-cell>
                                        <md-table-cell>{{ monthInfo.workingDays }}</md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>Working hours</md-table-cell>
                                        <md-table-cell>{{ toHours(monthInfo.workingHours) }}</md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>Worked hours</md-table-cell>
                                        <md-table-cell>{{ toHours(monthInfo.workedHours) }}</md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>Saldo month</md-table-cell>
                                        <md-table-cell :class="{'text-danger' : monthInfo.workedHours < monthInfo.workingHours}">{{ toHours(monthInfo.workedHours - monthInfo.workingHours) }}</md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>Saldo to date</md-table-cell>
                                        <md-table-cell :class="{'text-danger' : monthInfo.workedHours < monthInfo.maxPossibleHours}">{{ toHours(monthInfo.workedHours - monthInfo.maxPossibleHours) }}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                            </md-tab>

                            <md-tab id="tab-quarter" md-label="Quarter" md-icon="dynamic_feed">
                                <md-table table-header-color="primary">
                                    <md-table-row>
                                        <md-table-cell>Transfer hours from last quarter</md-table-cell>
                                        <md-table-cell :class="{'text-danger' : transferHours < 0}">{{ toHours(transferHours) }}</md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>Working days</md-table-cell>
                                        <md-table-cell>{{ quarterInfo.workingDays }}</md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>Working hours</md-table-cell>
                                        <md-table-cell>{{ toHours(quarterInfo.workingHours) }}</md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>Worked hours</md-table-cell>
                                        <md-table-cell>{{ toHours(quarterInfo.workedHours) }}</md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>Saldo quarter</md-table-cell>
                                        <md-table-cell :class="{'text-danger' : quarterInfo.workedHours < quarterInfo.workingHours}">{{ toHours(quarterInfo.workedHours - quarterInfo.workingHours) }}</md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>Saldo to date</md-table-cell>
                                        <md-table-cell :class="{'text-danger' : quarterInfo.workedHours + transferHours < quarterInfo.maxPossibleHours}">{{ toHours((quarterInfo.workedHours + transferHours) - (quarterInfo.maxPossibleHours)) }}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                            </md-tab>

                            <md-tab id="tab-day" md-label="Day" md-icon="today">
                                <md-table table-header-color="primary">
                                    <md-table-row>
                                        <md-table-head>Project</md-table-head>
                                        <md-table-head>Issue</md-table-head>
                                        <md-table-head>Time spend</md-table-head>
                                    </md-table-row>
                                    <md-table-row v-for="(worklog, index) in selectedDay.worklogs" v-bind:key="index">
                                        <md-table-cell>{{ worklog.project }}</md-table-cell>
                                        <md-table-cell>{{ worklog.issue }}</md-table-cell>
                                        <md-table-cell>{{ toHours(worklog.time) }}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                                <p>Worked hours: {{ toHours(selectedDay.hours) }}</p>
                            </md-tab>
                        </md-tabs>
                    </template>
                </nav-tabs-card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "@/axios";
import utils from "@/utils.js";
import { StatsCard, ChartCard, NavTabsCard, NavTabsTable, OrderedTable } from "@/components";

export default {
    name: 'calendar',
    mixins: [utils],
    components: {
        StatsCard,
        ChartCard,
        NavTabsCard,
        NavTabsTable,
        OrderedTable,
    },
    data() {
        return {
            dates: [],
            month: '',
            monthInfo: {},
            monthIndex: null,
            quarterInfo: {},
            selectedDay: {},
            selectedIndex: 0,
            activeTab: 'tab-month',
            totalHours: 0,
            totalWorkedHours: 0,
        };
    },
    methods: {
        fetch(index) {
            let url = '/calendar';
            if(index) {
                url = '/calendar?month=' + index;
            }
            axios.get(url)
                .then(response => {
                    this.dates = response.data.dates;
                    this.monthInfo = response.data.monthInfo;
                    this.quarterInfo = response.data.quarterInfo;
                    this.monthIndex = response.data.monthIndex;
                    this.selectedIndex = this.dates.findIndex(date => {
                        return date.date == new Date().getDate() && date.inMonth;
                    });
                    this.month = response.data.month;
                    this.totalHours = response.data.totalHours;
                    this.totalWorkedHours = response.data.totalWorkedHours;
                })
        },
        selectDay(day, index) {
            this.selectedDay = day;
            this.selectedIndex = index;
            this.activeTab = 'tab-day';
        },
        previousMonth() {
            if(this.monthIndex > 1) {
                this.fetch(this.monthIndex - 1);
            }
        },
        nextMonth() {
            if(this.monthIndex < 12) {
                this.fetch(this.monthIndex + 1);
            }
        }
    },
    computed: {
        transferHours() {
            return this.totalWorkedHours - this.totalHours;
        }
    },
    beforeMount() {
        this.fetch();
    }
};
</script>
